import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const serviceModule: ForqModuleManifest = {
  id: 'service',
  name: 'Service',
  description: 'Außendienst- und Werkstattaufträge mit Papierunterlagen steuern',
  version: '0.1.0',
  route: '/service',
  category: 'operations',
  status: 'development',
  requiredPermissions: ['service.view'],
  features: [
    'service.worklist',
    'service.planning',
    'service.print',
    'service.paper-return',
    'service.approval',
  ],
  navigation: [
    { id: 'service.primary', label: 'Service', route: '/service', placement: 'primary', order: 21, icon: 'service' },
    { id: 'service.launcher', label: 'Service', route: '/service', placement: 'launcher', order: 21, icon: 'service' },
  ],
};

export const serviceFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'service.worklist', moduleId: 'service', name: 'Service-Arbeitsliste',
    description: 'Außendienst- und Werkstattaufträge nach Bearbeitungsstand', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['service.view'], uiSlots: [], emits: ['service.job.opened'], listensTo: ['tenant.changed', 'order.changed'],
  },
  {
    id: 'service.planning', moduleId: 'service', name: 'Serviceplanung',
    description: 'Termin, Ausführungsart, Techniker und Arbeitsbeschreibung planen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['service.plan'], uiSlots: [], emits: ['service.job.planned'], listensTo: ['order.changed'],
  },
  {
    id: 'service.print', moduleId: 'service', name: 'Papierauftrag',
    description: 'Versionierten Service- oder Werkstattauftrag erzeugen und drucken', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['service.print'], uiSlots: [], emits: ['service.print.created'], listensTo: ['service.job.planned'],
  },
  {
    id: 'service.paper-return', moduleId: 'service', name: 'Papier-Rückmeldung',
    description: 'Zurückgegebenen Serviceauftrag durch Verwaltung erfassen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['service.return.capture'], uiSlots: [], emits: ['service.paper-return.captured'], listensTo: ['service.print.created'],
  },
  {
    id: 'service.approval', moduleId: 'service', name: 'Werkstattfreigabe',
    description: 'Kundenentscheidung zur Werkstattreparatur dokumentieren', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['service.approval.manage'], uiSlots: [], emits: ['service.approval.changed'], listensTo: ['service.job.planned'],
  },
];
